module.exports = __webpack_public_path__ + "img/Roboto-Medium.95204ac.svg";